/**
 * Canvas section management of image editor
 */
function handleLayerSelection() {
  // 1. Deselectăm orice buton activ (Shapes, Stickers, etc.)
  $('.main-buttons button.active').removeClass('active');
}


(function () {
  'use strict';

  const updateManualInputs = (obj) => {
  if (!obj) return;
  const canvasW = fabricCanvas.getWidth();
  const canvasH = fabricCanvas.getHeight();

  const leftPercent = ((obj.left || 0) / canvasW) * 100;
  const topPercent = ((obj.top || 0) / canvasH) * 100;
  const angle = obj.angle || 0;

  $(`${editor.containerSelector} .toolpanel#select-panel .manual-position-section #manual-left`).val(leftPercent.toFixed(2));
  $(`${editor.containerSelector} .toolpanel#select-panel .manual-position-section #manual-top`).val(topPercent.toFixed(2));
  $(`${editor.containerSelector} .toolpanel#select-panel .manual-position-section #manual-rotate`).val(angle.toFixed(2));
};


  window.updateLayersList = function () {
    const list = document.getElementById('layers-list');
    const objects = window.fabricCanvas.getObjects();
    list.innerHTML = '';

    [...objects].reverse().forEach((obj, index) => {
      const item = document.createElement('li');
      item.innerHTML = `
        <span>${obj.type} #${objects.length - index}</span>
        <button class="layer-up">↑</button>
        <button class="layer-down">↓</button>
      `;
      item.dataset.index = index;
      list.appendChild(item);
    });

    document.querySelectorAll('.layer-up').forEach((btn, i) => {
      btn.onclick = () => moveLayerUp(objects.length - 1 - i);
    });
    document.querySelectorAll('.layer-down').forEach((btn, i) => {
      btn.onclick = () => moveLayerDown(objects.length - 1 - i);
    });
  }

  function moveLayerUp(index) {
    const objects = window.fabricCanvas.getObjects();
    if (index < objects.length - 1) {
      window.fabricCanvas.bringForward(objects[index]);
      window.fabricCanvas.renderAll();
      window.updateLayersList();
    }
  }

  function moveLayerDown(index) {
    const objects = window.fabricCanvas.getObjects();
    if (index > 0) {
      window.fabricCanvas.sendBackwards(objects[index]);
      window.fabricCanvas.renderAll();
      window.updateLayersList();
    }
  }

  
  var canvas = function () {
    try {
      $(`${this.containerSelector} .main-panel`).append(`<div class="canvas-holder" id="canvas-holder"><div class="content"><canvas id="c"></canvas></div></div>`);
      const fabricCanvas = new fabric.Canvas('c').setDimensions({
  width: 800,
  height: 600
      })




      canvas.controlsInStack = true

      const canvasContent = document.querySelector('.canvas-holder .content');
if (canvasContent) {
  canvasContent.style.marginTop = '70px';
}

      

      window.fabricCanvas = fabricCanvas;
      window.editor = this; // needed for undo to access history
this.history = [];
      this.redoStack = [];
      let copiedObject = null;



      fabricCanvas.on('object:added', () => {
  if (panel.style.display === 'block') window.updateLayersList();
});
fabricCanvas.on('object:removed', () => {
  if (panel.style.display === 'block') window.updateLayersList();
});
fabricCanvas.on('object:modified', () => {
  if (panel.style.display === 'block') window.updateLayersList();
  updateManualInputs(fabricCanvas.getActiveObject());
});
fabricCanvas.on('object:moving', function (e) {
  const obj = e.target;

  if (!obj.selectable) return; // prevenim erori de la shadow-copy

  obj.setCoords();

  const zoom = fabricCanvas.getZoom();
  const canvasWidth = fabricCanvas.getWidth() / zoom;
  const canvasHeight = fabricCanvas.getHeight() / zoom;

  const objWidth = obj.getScaledWidth();
  const objHeight = obj.getScaledHeight();

  const visiblePartX = objWidth * 0.1;
  const visiblePartY = objHeight * 0.1;

  const minX = -objWidth + visiblePartX;
  const minY = -objHeight + visiblePartY;
  const maxX = canvasWidth - visiblePartX;
  const maxY = canvasHeight - visiblePartY;

  obj.left = Math.min(Math.max(obj.left, minX), maxX);
  obj.top = Math.min(Math.max(obj.top, minY), maxY);

  obj.setCoords();
});





      // Adaugă imaginea ca layer în canvas (imaginea de fundal)


      fabricCanvas.originalW = fabricCanvas.width;
      fabricCanvas.originalH = fabricCanvas.height;

      // set up selection style
      fabric.Object.prototype.transparentCorners = false;
      fabric.Object.prototype.cornerStyle = 'circle';
      fabric.Object.prototype.borderColor = '#C00000';
      fabric.Object.prototype.cornerColor = '#C00000';
      fabric.Object.prototype.cornerStrokeColor = '#FFF';
      fabric.Object.prototype.padding = 0;

      // ✅ Adăugat pentru a activa control points la CurvedText
if (fabric.CurvedText) {
  fabric.CurvedText.prototype.controls = fabric.Object.prototype.controls;
}

      // retrieve active selection to react state
fabricCanvas.on('selection:created', (e) => {
  this.setActiveSelection(e.target);
  updateManualInputs(e.target);
  
  showLayersPanelAndHighlight(e.target);
  updateGroupButtons();

  handleCurvedTextCircles(e.target);
  handleLayerSelection();

  toggleCurveTextPropsPanel(e.target);
});

    const updateGroupButtons = () => {
  const active = fabricCanvas.getActiveObject();
  const $groupPanel = $(`${this.containerSelector} .toolpanel#select-panel .object-options`);

  if (active && active.type === 'activeSelection' && active._objects.length >= 2) {
    $groupPanel.show();
  } else {
    $groupPanel.hide();
  }
};


fabricCanvas.on('selection:updated', (e) => {
  this.setActiveSelection(e.target);
  showLayersPanelAndHighlight(e.target);
  updateManualInputs(e.target);
  updateGroupButtons();

  handleCurvedTextCircles(e.target);
  handleLayerSelection();

  toggleCurveTextPropsPanel(e.target);
});

      fabricCanvas.on('selection:cleared', (e) => {
        this.setActiveSelection(null)
        updateGroupButtons();
                                                  })

      // snap to an angle on rotate if shift key is down
      fabricCanvas.on('object:rotating', (e) => {
        if (e.e.shiftKey) {
          e.target.snapAngle = 15;
        } else {
          e.target.snapAngle = false;
        }
      })

      fabricCanvas.on('object:modified', () => {
        console.log('trigger: modified')
        let currentState = this.canvas.toJSON();
        this.history.push(JSON.stringify(currentState));
        this.redoStack = [];
      })

      

      const savedCanvas = saveInBrowser.load('canvasEditor');
      if (savedCanvas) {
        fabricCanvas.loadFromJSON(savedCanvas, fabricCanvas.renderAll.bind(fabricCanvas));
      }

      // move objects with arrow keys
      (() => document.addEventListener('keydown', (e) => {
        const key = e.which || e.keyCode;
        let activeObject;

        if (document.querySelectorAll('textarea:focus, input:focus').length > 0) return;

        if (key === 37 || key === 38 || key === 39 || key === 40) {
          e.preventDefault();
          activeObject = fabricCanvas.getActiveObject();
          if (!activeObject) {
            return;
          }
        }

        if (key === 37) {
          activeObject.left -= 1;
        } else if (key === 39) {
          activeObject.left += 1;
        } else if (key === 38) {
          activeObject.top -= 1;
        } else if (key === 40) {
          activeObject.top += 1;
        }

        if (key === 37 || key === 38 || key === 39 || key === 40) {
          activeObject.setCoords();
          fabricCanvas.renderAll();
          fabricCanvas.trigger('object:modified');
        }
      }))();

      // delete object on del key
      (() => {
        document.addEventListener('keydown', (e) => {
          const key = e.which || e.keyCode;
          if (
            (key === 46 || key === 8) &&
            document.querySelectorAll('textarea:focus, input:focus').length === 0
          ) {

            fabricCanvas.getActiveObjects().forEach(obj => {
              fabricCanvas.remove(obj);
            });

            fabricCanvas.discardActiveObject().requestRenderAll();
            fabricCanvas.trigger('object:modified')
          }
        })
      })();

      setTimeout(() => {
        let currentState = fabricCanvas.toJSON();
        this.history.push(JSON.stringify(currentState));
      }, 1000);

      // -- CTRL+Z Undo Keybinding --
document.addEventListener('keydown', function (e) {
  const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
  const isUndo = (isMac && e.metaKey && e.key === 'z' && !e.shiftKey) || (!isMac && e.ctrlKey && e.key === 'z' && !e.shiftKey);
  const isRedo = (isMac && e.metaKey && e.shiftKey && e.key === 'z') || (!isMac && ((e.ctrlKey && e.key === 'y') || (e.ctrlKey && e.shiftKey && e.key === 'z')));

  if (isUndo) {
    e.preventDefault();
    if (window.fabricCanvas && window.editor && Array.isArray(window.editor.history)) {
      const currentState = window.editor.history.pop();
      if (currentState) {
        window.editor.redoStack.push(currentState);
        const lastState = window.editor.history[window.editor.history.length - 1];
        if (lastState) {
          window.fabricCanvas.loadFromJSON(lastState, () => {
            window.fabricCanvas.renderAll();
          });
        }
      }
    }
  }

  if (isRedo) {
    e.preventDefault();
    if (window.fabricCanvas && window.editor && Array.isArray(window.editor.redoStack)) {
      const redoState = window.editor.redoStack.pop();
      if (redoState) {
        window.editor.history.push(redoState);
        window.fabricCanvas.loadFromJSON(redoState, () => {
          window.fabricCanvas.renderAll();
        });
      }
    }
  }

    // Ctrl+C – copy
  if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'c') {
    e.preventDefault();
    
    const active = fabricCanvas.getActiveObject();
    if (active) {
      active.clone(function (cloned) {
        copiedObject = cloned;
        console.log('Copied:', copiedObject.type);
      });
    }
  }

  // Ctrl+V – paste
  if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'v') {
    e.preventDefault();
    
    if (copiedObject) {
      copiedObject.clone(function (clonedObj) {
        clonedObj.set({
          left: (copiedObject.left || 10) + 20,
          top: (copiedObject.top || 10) + 20,
          evented: true
        });

        if (clonedObj.type === 'activeSelection') {
          // Group paste
          clonedObj.canvas = fabricCanvas;
          clonedObj.forEachObject(obj => fabricCanvas.add(obj));
          clonedObj.setCoords();
        } else {
          fabricCanvas.add(clonedObj);
        }

        fabricCanvas.setActiveObject(clonedObj);
        fabricCanvas.requestRenderAll();

        // Save new state
        let currentState = fabricCanvas.toJSON();
        window.editor.history.push(JSON.stringify(currentState));
      });
    }
  }

});

      

      


      return fabricCanvas;
    } catch (_) {
      console.error("can't create canvas instance");
      return null;
    }

    function handleCurvedTextCircles(selected) {
  const allObjects = fabricCanvas.getObjects();

  allObjects.forEach(obj => {
    if (obj.type === 'curveText') {
      const isStillSelected = selected === obj || selected === obj.p0 || selected === obj.p1 || selected === obj.p2;
      if (isStillSelected) {
        obj.restoreCircles?.();
      } else {
        obj.onDeselect?.();
      }
    }
  });
}

    

  }

  window.ImageEditor.prototype.initializeCanvas = canvas;

  ImageEditor.prototype.undo = function () {
  if (!this.history || this.history.length < 2) return;

  const currentState = this.history.pop();
  this.redoStack.push(currentState);
  const lastState = this.history[this.history.length - 1];

  if (lastState) {
    window.fabricCanvas.loadFromJSON(lastState, () => {
      window.fabricCanvas.renderAll();
    });
  }
};

ImageEditor.prototype.redo = function () {
  if (!this.redoStack || this.redoStack.length === 0) return;

  const redoState = this.redoStack.pop();
  this.history.push(redoState);
  window.fabricCanvas.loadFromJSON(redoState, () => {
    window.fabricCanvas.renderAll();
  });
};

})();